import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'

export const INPUT = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.extra.space.Cluster.Input,
    graphql.schema.ClusterInput
  >({
    description: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
    organizationId: graphql.transformers.IN.validate(
      transformers.PASS_THROUGH,
      ents.extra.space.Organization.Id.assertIsId,
    ),
  }),
)

export const UPDATES = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    Partial<ents.extra.space.Cluster.Update>,
    graphql.schema.ClusterUpdateInput
  >({
    comment: transformers.PASS_THROUGH,
    description: transformers.PASS_THROUGH,
    name: graphql.transformers.IN.validate(
      transformers.PASS_THROUGH,
      TypeAsserter.assertIsNotNullish,
      { warnOnly: true },
    ),
  }),
)
